(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sn-collection-sort"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function(event) {
  if (!event.target.matches('[data-sn-sort-form]')) return;
  event.preventDefault();
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', new FormData(event.target).get('sort_by'));
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});
  } catch(e) { console.error(e); }
})();

})();
